
import { IApplicationDirector } from './director.interface';
import { Channels } from './channels';
import { Mediator } from '../mediator';
import { BehaviorSubject, Observable } from 'rxjs';

class Dependencies {}

class ApplicationDirector extends Mediator implements IApplicationDirector {
    public events: Channels = new Channels();
    public user: any;   
    
    
    init(options: Dependencies) {
        var publishers = {
            [ this.events['AUTHENTICATION:USER'] ]: this.handleUser
        };
        
        this.register('publishers', publishers);
        
        return this;
    }
     
    
    protected handleUser(channel: string, user: any) {
        this.user = user;
        this.dispatch(channel, user);
    }
    
    protected handleUserExit(channel: string) {
        delete this.user;
        this.dispatch(channel);
    }
    
}

export { ApplicationDirector, Dependencies };
